export class Address {
    street = '';
    number = '';
    postalCode = '';
    countryCode = '';
    city = '';
    extraLine: string | undefined;

    serialize(): any {
        return {
            street: this.street,
            number: this.number,
            'postal_code': this.postalCode,
            'country_code': this.countryCode,
            city: this.city,
            'extra_line': this.extraLine,
        };
    }

    deserialize(data: any): this {
        this.street = data.street ?? '';
        this.number = data.number ?? '';
        this.postalCode = data.postal_code ?? '';
        this.city = data.city ?? '';
        this.countryCode = data.country_code ?? '';
        this.extraLine = data.extra_line ?? undefined;
        return this;
    }

    clone(): Address {
        return new Address().deserialize(this.serialize());
    }
}

type SupportedCountry = {
    name: string;
    code: string;
};
export const supportedCountries: SupportedCountry[] = [
    {
        name: $localize`:@@austria:Oostenrijk`,
        code: 'AT',
    },
    {
        name: $localize`:@@belgium:België`,
        code: 'BE',
    },
    {
        name: $localize`:@@bulgaria:Bulgarije`,
        code: 'BG',
    },
    {
        name: $localize`:@@cyprus:Cyprus`,
        code: 'CY',
    },
    {
        name: $localize`:@@czechRepublic:Tsjechië`,
        code: 'CZ',
    },
    {
        name: $localize`:@@germany:Duitsland`,
        code: 'GE',
    },
    {
        name: $localize`:@@danmark:Denemarken`,
        code: 'DK',
    },
    {
        name: $localize`:@@estonia:Estland`,
        code: 'EE',
    },
    {
        name: $localize`:@@greece:Griekenland`,
        code: 'EL',
    },
    {
        name: $localize`:@@spain:Spanje`,
        code: 'ES',
    },
    {
        name: $localize`:@@finalnd:Finland`,
        code: 'FI',
    },
    {
        name: $localize`:@@france:Frankrijk`,
        code: 'FR',
    },
    {
        name: $localize`:@@uk:Verenigd Koninkrijk`,
        code: 'GB',
    },
    {
        name: $localize`:@@croatia:Kroatië`,
        code: 'HR',
    },
    {
        name: $localize`:@@hungary:Hongarije`,
        code: 'HU',
    },
    {
        name: $localize`:@@ireland:Ierland`,
        code: 'IE',
    },
    {
        name: $localize`:@@italy:Italië`,
        code: 'IT',
    },
    {
        name: $localize`:@@lithuania:Litouwen`,
        code: 'LT',
    },
    {
        name: $localize`:@@luxemburgh:Luxemburg`,
        code: 'LU',
    },
    {
        name: $localize`:@@latvia:Letland`,
        code: 'LV',
    },
    {
        name: $localize`:@@malta:Malta`,
        code: 'MT',
    },
    {
        name: $localize`:@@netherlands:Nederland`,
        code: 'NL',
    },
    {
        name: $localize`:@@poland:Polen`,
        code: 'PL',
    },
    {
        name: $localize`:@@portugal:Portugal`,
        code: 'PT',
    },
    {
        name: $localize`:@@romania:Roemenië`,
        code: 'RO',
    },
    {
        name: $localize`:@@sweden:Zweden`,
        code: 'SE',
    },
    {
        name: $localize`:@@slovenia:Slovenië`,
        code: 'SV',
    },
    {
        name: $localize`:@@slovakia:Slowakije`,
        code: 'SK',
    },
].sort((c1, c2) => c1.name.localeCompare(c2.name));
